/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { representantesRoles } from 'app/shared/listaRoles';

export const defaultNavigation: FuseNavigationItem[] = [
    
];
export const compactNavigation: FuseNavigationItem[] = [
    
    
];
export const futuristicNavigation: FuseNavigationItem[] = [
   
];
export const horizontalNavigation: FuseNavigationItem[] = [
    
    {
        id   : 'usuarios',
        title: 'Usuarios',
        type : 'group',
        icon : 'heroicons_outline:user-group',
        permissions: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'],
        children: [
            {
                id   : 'usuarios.nuevo',
                title: 'Nuevo usuario',
                type : 'basic',
                icon : 'heroicons_outline:user-plus',
                link : '/nuevo-usuario',
            },
            {
                id   : 'usuarios.lista',
                title: 'Lista de usuarios',
                type : 'basic',
                icon : 'heroicons_outline:list-bullet',
                link : '/usuarios',
            },
        ]
    },
    {
        id   : 'dependencias',
        title: 'Dependencias',
        type : 'group',
        icon : 'heroicons_outline:building-office',
        permissions: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'],
        children: [
            {
                id   : 'dependencias.nuevo',
                title: 'Nueva dependencia',
                type : 'basic',
                icon : 'heroicons_outline:plus-circle',
                link : '/nueva-dependencia',
            },
            {
                id   : 'dependencias.lista',
                title: 'Lista de dependencias',
                type : 'basic',
                icon : 'heroicons_outline:list-bullet',
                link : '/dependencias',
            },
        ]
    },
    {
        id   : 'formatos',
        title: 'Formatos',
        type : 'group',
        icon : 'heroicons_outline:document-text',
        permissions: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'],
        children: [
            {
                id   : 'formato.lista',
                title: 'Lista de formatos',
                type : 'basic',
                icon : 'heroicons_outline:list-bullet',
                link : '/formatos',
            },
        ]
    },
    {
        id   : 'MProcesos',
        title: 'Mi entrega',
        type : 'basic',
        icon : 'heroicons_outline:inbox',
        permissions: ['ROLE_ADMIN','SERVIDOR_PUBLICO','COORDINADOR_CONTRALORIA'],
        link : '/usuario-inicio'
    },
    {
        id   : 'MProcesos',
        title: 'Entregas',
        type : 'basic',
        icon : 'heroicons_outline:inbox-stack',
        permissions: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA','REPRESENTANTE_CONTRALORIA'],
        link : '/procesos'
    },
    {
        id   : 'Representantes',
        title: 'Representantes',
        type : 'basic',
        icon : 'heroicons_outline:users',
        permissions: ['ROLE_ADMIN','COORDINADOR_RH','COORDINADOR_RM',...representantesRoles],
        link : '/representantes'
    },
    {
        id   : 'Capturista',
        title: 'Capturista',
        type : 'basic',
        icon : 'heroicons_outline:folder-open',
        permissions: ['ROLE_ADMIN','CAPTURISTA'],
        link : '/capturista'
    },
    {
        id   : 'c-capturista',
        title: 'Catalogo capturista',
        type : 'basic',
        icon : 'heroicons_outline:wallet',
        permissions: ['ROLE_ADMIN','COORDINADOR_CONTRALORIA'],
        link : '/catalogo-capturista'
    },
    {
        id   : 'analitica',
        title: 'Analítica ',
        type : 'group',
        icon : 'heroicons_outline:chart-bar-square',
        permissions: ['ROLE_ADMIN','ANALITICA'],
        children: [
            {
                id   : 'dashboard',
                title: 'Tablero',
                type : 'basic',
                icon : 'heroicons_outline:chart-bar',
                link : '/dashboard',
            },
            {
                id   : 'dashboard-dependencia',
                title: 'Tablero Dependencia',
                type : 'basic',
                icon : 'heroicons_outline:chart-bar',
                link : '/dashboard-dependencia',
            },
            {
                id   : 'tablero-formatos',
                title: 'Tablero Formatos',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/tablero-formatos',
            },
        ]
    }
];


/*export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Inicio',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/example'
    },
    {
        id   : 'new-link',
        title: 'Solicitudes',
        type : 'basic',
        icon : 'heroicons_outline:document', 
        link : '/tablasolicitud' 
    },
    {
        id   : 'rub',
        title: 'RUB',
        type : 'basic',
        icon : 'heroicons_outline:identification', 
        link : '/rub' 
    },
    {
        id   : 'catalogos',
        title: 'Catálogos',
        type : 'basic',
        icon : 'heroicons_outline:document-duplicate', 
        link : '/catalogo' 
    },
    {
        id   : 'tablacitas',
        title: 'Citas',
        type : 'basic',
        icon : 'heroicons_outline:calendar-days', 
        link : '/tablacitas' 
    }
    

    
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];*/
